// checks for {{value}} in the text
export const bracketsRegex = /\{\{(.*?)\}\}/g;

// checks for <strong>value</strong> in the text
export const strongRegex = /(<strong>)(.*?)(<\/strong>)/g;

/**
 *
 * @param text The script text including the script fields
 * @returns The preview text with the script fields replaced by 'preview'
 */
export const getPreviewText = (text: string) => {
    return text?.replace(/{{[^}]+}}/g, 'preview');
};
